import useFetcher from 'hooks/useFetcher/useFetcher';
import { ServiceTypes } from 'hooks/useFetcher/interfaces';
import { stringifyUrl, getRequest } from 'utils';
import { Properties } from 'types';

export const useCallsAPI = (): Properties => {
  const fetcher = useFetcher(ServiceTypes.CRM);

  return {
    getCalls: ({ queryKey: [, query] }) => {
      return fetcher(stringifyUrl(`/calls`, query), getRequest);
    },

    postCallsOneC: ({ id }) => {
      return fetcher(`/calls/${id}/one-c`, {
        request: {
          method: 'POST',
        },
      });
    },

    editCall: ({ id, data }) => {
      return fetcher(`/calls/${id}`, {
        request: {
          method: 'PATCH',
        },
        data,
      });
    },

    deleteCalls: (ids: number[]) => {
      return fetcher(stringifyUrl(`/calls/bulk-delete`, { ids }), {
        request: {
          method: 'DELETE',
        },
      });
    },
  };
};
